import { useState } from "react";
import { useAuthContext } from "./agencyAuthHook";
import toast from "react-hot-toast";
import { Link,useNavigate  } from 'react-router-dom'
export default function LoginHook() {
      const navigate = useNavigate()
  const apiUrl = process.env.REACT_APP_API_URL;
  const { dispatch } = useAuthContext();
  const [isLoading, setLoading] = useState(false);

  const storeUserData = (key, data, rememberMe) => {
    if (rememberMe) {
      localStorage.setItem(key, JSON.stringify(data));
    } else {
      sessionStorage.setItem(key, JSON.stringify(data));
    }
  };
  // Fetching API endpoint to register a new seller
  const agencyLogin = async ( contact, password,rememberMe) => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          setLoading(true);
          const response = await fetch(`${apiUrl}/api/agencies/login`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email:contact, password }),
          });

          const json = await response.json();

          if (response.ok) {
            resolve(json.message); 
            if(json.redirect){
              sessionStorage.setItem("email", contact);
          
              navigate('/email_verification'); 
            }
            else{
              storeUserData('agency', json, rememberMe);
           
              dispatch({ type: "AGENCY_LOGIN", payload: json });
            }
          
          } else {
            reject(new Error(json.message || "Login failed.")); // Use actual API message for error
          }
        } catch (error) {
          reject(new Error(error.message || "Unexpected error occurred.")); // Handle unexpected errors
        } finally {
          setLoading(false);
        }
      }),
      {
        loading: "Logging you in...",
        success: (message) => <b>{message || "Login successfully!"}</b>, // Use dynamic message for success
        error: (error) => <b>{error.message || "Failed to Login."}</b>, // Use dynamic message for error
      }
    );
  };

  return { isLoading, agencyLogin };
}
